"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIcon = exports.getTitle = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const getTitle = (options = {}, focused = false, theme = core_1.BlueBaseTheme) => {
    const { tabBarOptions = {} } = options;
    const label = options.tabBarLabel || options.title || options.headerTitle;
    if (!tabBarOptions.showLabel || !label) {
        return;
    }
    const activeTintColor = tabBarOptions.activeTintColor || theme.palette.text.primary;
    const inactiveTintColor = tabBarOptions.inactiveTintColor || theme.palette.text.secondary;
    const tintColor = focused ? activeTintColor : inactiveTintColor;
    if (typeof label === 'function') {
        return label({ focused, tintColor });
    }
    return (react_1.default.createElement(components_1.Text, { testID: "tab-title", style: Object.assign({ color: tintColor }, tabBarOptions.labelStyle) }, label));
};
exports.getTitle = getTitle;
const getIcon = (options = {}, focused = false, theme = core_1.BlueBaseTheme) => {
    const { tabBarOptions = {} } = options;
    const icon = options.tabBarIcon;
    if (!tabBarOptions.showIcon) {
        return;
    }
    const activeTintColor = tabBarOptions.activeTintColor || theme.palette.text.primary;
    const inactiveTintColor = tabBarOptions.inactiveTintColor || theme.palette.text.secondary;
    const tintColor = focused ? activeTintColor : inactiveTintColor;
    if (typeof icon === 'function') {
        return icon({
            focused,
            horizontal: !core_1.isMobile(),
            tintColor,
        });
    }
    if (icon && typeof icon.type === 'string') {
        return icon;
    }
};
exports.getIcon = getIcon;
